import { Component, OnInit, Input, Self, Optional, ViewChild, EventEmitter, Output } from '@angular/core';
import { NgControl, ControlValueAccessor } from '@angular/forms';
import * as uuid from 'uuid';

@Component({
    selector: 'app-form-radio',
    templateUrl: './radio.component.html',
    styleUrls: ['./radio.component.scss'],
})
export class FormRadioComponent implements OnInit, ControlValueAccessor {
    public onChange: (x?: any) => void;

    public onTouched: (x?: any) => void;

    public id: string;

    public _value: any = '';

    public name: string | number;

    public checked: boolean;

    @Input() disabled: boolean;

    @Input() val: string;

    @Input() validation = false;

    @Input() enableMessages = true;

    @Output('change') changeOutput = new EventEmitter<any>();

    @ViewChild('input', { static: true }) input;

    constructor(@Self() @Optional() private ngControl: NgControl) {
        if (this.ngControl) {
            this.ngControl.valueAccessor = this;
        }
    }

    ngOnInit(): void {
        this.id = uuid.v4();

        if (this.ngControl) {
            this.checked = this.ngControl.value === this.val;
            this.name = this.ngControl.name;
        } else {
            this.name = uuid.v4();
        }
    }

    get invalid(): boolean {
        if (this.ngControl) {
            return this.ngControl.invalid;
        }
        return false;
    }

    get valid(): boolean {
        if (this.ngControl) {
            return this.ngControl.valid;
        }
        return false;
    }

    get pristine(): boolean {
        if (this.ngControl) {
            return this.ngControl.pristine;
        }
        return false;
    }

    get dirty(): boolean {
        if (this.ngControl) {
            return this.ngControl.dirty;
        }
        return false;
    }

    get touched(): boolean {
        if (this.ngControl) {
            return this.ngControl.touched;
        }
        return false;
    }

    get value(): any {
        return this._value;
    }

    set value(v) {
        this._value = v;
        if (this.ngControl) {
            this.checked = this.ngControl.value === this.val;
        }
        if (this.onChange) {
            this.changeOutput.emit(v);
            this.onChange(v);
            this.onTouched();
        }
    }

    change(v): void {
        this.value = v;
    }

    writeValue(value: any): void {
        this.value = value;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    registerOnChange(fn: any): void {
        // Store the provided function as an internal method.
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        // Store the provided function as an internal method.
        this.onTouched = fn;
    }
}
